<template>
	<div class="kt-portlet kt-portlet--height-fluid">
		<AddQuestion v-model="dialogs.addQuestion"></AddQuestion>
		<div
			class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
		>
			<div class="kt-portlet__head-label">
				<span class="kt-portlet__head-icon">
					<i class="fal fa-book"></i>
				</span>
				<h3 class="kt-portlet__head-title">Custom Form Builder</h3>
			</div>
		</div>
		<div class="kt-portlet__body">
			<div class="row">
				<div class="col-12">
					<v-data-table :headers="headers" :items="questions">
						<template v-slot:top>
							<div class="row">
								<div class="col-4">
									<v-text-field
										label="Custom Form Title"
										v-validate="'required'"
										name="form.title"
										v-model="form.title"
										class="inline"
									></v-text-field>
									<span
										class="kt-font-danger validate-error"
										v-show="errors.has('form.title')"
										>{{ errors.first('form.title') }}</span
									>
								</div>
								<div class="col">
									<div class="float-right">
										<v-btn
											color="primary"
											class="text--white"
											dark
											style="color: white !important"
											@click.stop="openForm"
										>
											Add Question
										</v-btn>
									</div>
								</div>
							</div>
						</template>
						<template v-slot:item.answers="{ item }">
							<p
								v-for="(answer, index) in item.answers"
								v-bind:key="index"
								:class="
									answer.isCorrect || answer.is_correct ? 'text-success' : 'text-danger'
								"
							>
								{{ answer.value }}
							</p>
						</template>
						<template v-slot:item.actions="{ item }">
							<button type="button" class="btn btn-label-info btn-sm btn-icon units-btn">
								<i class="fal fa-edit" />
							</button>
							<button
								type="button"
								class="btn btn-label-dark btn-sm btn-icon units-btn"
								@click="removeQuestion(item)"
							>
								<i class="far fa-trash" />
							</button>
						</template>
					</v-data-table>
				</div>
				<div class="col-12">
					<div class="float-right">
						<v-btn
							color="blue darken-3 text--white"
							dark
							style="color: white !important"
							:loading="loading"
							@click="saveForm"
						>
							Save
						</v-btn>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isEmpty as _isEmpty, findIndex as _findIndex } from 'lodash-es';
import AddQuestion from '../../components/internet-shop-custom-forms/AddQuestion.vue';

export default {
  name: 'CreateCustomForm',
  components: {
    AddQuestion,
  },
  data() {
    return {
      dialogs: {
        addQuestion: false,
      },
      form: {
        title: '',
      },
      headers: [
        {
          text: 'Question',
          align: 'left',
          value: 'question',
          sortable: true,
        },
        {
          text: 'Answers',
          align: 'left',
          value: 'answers',
          sortable: true,
        },
        {
          text: 'Question Type',
          align: 'left',
          value: 'question_type',
          sortable: true,
        },
        {
          text: 'Actions',
          align: 'center',
          width: 120,
          value: 'actions',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    questions() {
      return this.$store.state.internetShopCustomForm.questions;
    },
  },
  created() {},
  mounted() {
    this.$validator.localize('en', {
      attributes: {
        'form.title': 'title',
      },
    });
  },
  methods: {
    openForm() {
      this.dialogs.addQuestion = true;
    },
    saveForm() {
      if (_isEmpty(this.questions)) {
        this.$notify('warning', 'Please add question(s)');
        return;
      }
      this.$validator.validate('*').then((result) => {
        if (result) {
          this.axios
            .post('v3/internet-shops/custom-forms', {
              title: this.form.title,
              questions: this.questions,
            })
            .then(() => {
              this.$notify('success', 'Custom form created successfully!');
              this.resetState();
            });
        }
      });
    },
    resetState() {
      this.form.title = null;
	  this.$store.dispatch('internetShopCustomForm/resetQuestions');
    },
    removeQuestion(item) {
      const index = _findIndex(this.questions, item);
      this.$store.dispatch('internetShopCustomForm/removeQuestion', index);
    },
  },
};
</script>

<style scoped></style>
